import { OrderDirection } from '../../common/enums/order-direction.enum';
import { IPaginatedEntity } from '../../common/interfaces/paginated-entity.interface';
import { CompanyStatus, ICompany, ICompanyDTO } from '../../common/interfaces/company.interface';
import { supabase } from '../../common/config/supabase';

export const getCompanies = async (
  limit: number,
  page: number,
  search?: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
  status?: CompanyStatus,
): Promise<IPaginatedEntity<ICompany>> => {
  const { data, error } = await supabase.rpc('get_companies', {
    name_val: search || '',
    status_val: status,
    limit_val: limit,
    page_val: page,
    order_direction: orderDirection,
    order_by: orderBy,
  });

  if (error) {
    throw error;
  }

  return {
    items: data,
    meta: {
      currentPage: page,
      itemCount: data.length,
      itemsPerPage: limit,
      totalItems: data[0] ? data[0].total_count : 0,
      totalPages: data[0] ? Math.ceil(+data[0].total_count / limit) : 0,
      orderByColumn: orderBy,
      orderDirection: orderDirection,
    },
  };
};

export const addCompany = async (company: ICompanyDTO): Promise<ICompany | null> => {
  const { data, error } = await supabase.from('companies').insert({
    name: company.name,
    contact: company.contact,
  });

  if (error) {
    throw error;
  }

  return data;
};

export const updateCompany = async (company: ICompanyDTO): Promise<ICompany | null> => {
  if (!company.id) {
    return null;
  }

  const { data, error } = await supabase
    .from('companies')
    .update({
      name: company.name,
      contact: company.contact,
      status: company.status,
    })
    .eq('id', company.id);

  if (error) {
    throw error;
  }

  return data;
};
